"use client"

import styled from "styled-components"
import { Area, AreaChart, ResponsiveContainer, XAxis, YAxis } from "recharts"
import {
  Badge,
  BigValue,
  Card,
  CardHeader,
  StatGrid,
  StatLabel,
  StatValue,
  Subtitle,
  Title,
  TitleGroup,
  Unit,
} from "./primitives"

const traffic = [
  { m: "Aug", v: 18.2 },
  { m: "Sep", v: 19.1 },
  { m: "Oct", v: 20.4 },
  { m: "Nov", v: 22.0 },
  { m: "Dec", v: 24.6 },
  { m: "Jan", v: 26.9 },
]

const TopRow = styled.div`
  margin-top: 1rem;
  display: flex;
  align-items: baseline;
  gap: 0.5rem;
`

const ChartWrap = styled.div`
  margin-top: 0.75rem;
  height: 7rem;
  width: 100%;
`

export function WebTrafficCard() {
  return (
    <Card>
      <CardHeader>
        <TitleGroup>
          <Title>Digital engagement</Title>
          <Subtitle>Monthly unique visitors</Subtitle>
        </TitleGroup>
        <Badge tone="optimal">+47% YoY</Badge>
      </CardHeader>

      <TopRow>
        <BigValue>26.9M</BigValue>
        <Unit>visitors in Jan</Unit>
      </TopRow>

      <ChartWrap>
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={traffic} margin={{ top: 8, right: 4, bottom: 0, left: -20 }}>
            <defs>
              <linearGradient id="trafficFill" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="var(--color-optimal)" stopOpacity={0.25} />
                <stop offset="100%" stopColor="var(--color-optimal)" stopOpacity={0} />
              </linearGradient>
            </defs>
            <XAxis
              dataKey="m"
              tickLine={false}
              axisLine={false}
              tick={{ fill: "var(--color-muted-foreground)", fontSize: 11 }}
              dy={6}
            />
            <YAxis hide domain={["dataMin - 2", "dataMax + 2"]} />
            <Area
              type="monotone"
              dataKey="v"
              stroke="var(--color-optimal)"
              strokeWidth={2.5}
              fill="url(#trafficFill)"
              isAnimationActive={false}
            />
          </AreaChart>
        </ResponsiveContainer>
      </ChartWrap>

      <StatGrid>
        <div>
          <StatLabel>Avg. session</StatLabel>
          <StatValue>4m 12s</StatValue>
        </div>
        <div>
          <StatLabel>Bounce rate</StatLabel>
          <StatValue $tone="optimal">38%</StatValue>
        </div>
        <div>
          <StatLabel>App DAU</StatLabel>
          <StatValue>3.1M</StatValue>
        </div>
      </StatGrid>
    </Card>
  )
}

export default WebTrafficCard
